<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Modalidade Financiamento</h2>
    </div>

    <div class="tds-row" >
        <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width (tdsFilter)="onFilterEvent($event)" (tdsSort)="onSortEvent($event)" >
            <tds-table-toolbar filter tdsSearchAriaLabel="Pesquisar por código ou descrição">
            </tds-table-toolbar>
            <tds-table-header>
                <tds-header-cell cell-key='id' cell-value='Código' sortable="true" sorting="asc"></tds-header-cell>
                <tds-header-cell cell-key='descricao' cell-value='Descrição' sortable="true" sorting="asc"></tds-header-cell>
            </tds-table-header>
            <tds-table-body>
                <tds-table-body-row *ngFor="let financing of financings | paginate : { itemsPerPage: pageSize, currentPage: page }"> 
                    <tds-body-cell cell-key="id">{{ financing.id }}</tds-body-cell>
                    <tds-body-cell cell-key="descricao">{{ financing.descricao }}</tds-body-cell>
                </tds-table-body-row>
            </tds-table-body>
        </tds-table>
        <div class="pagination-wrapper">
            <pagination-controls  class="my-pagination" (pageChange)="page = $event" ></pagination-controls>
        </div>
    </div>
</div>